import {
  Box,
  Button,
  Card,
  Container,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import OrderGrid from "../../../compenents/Customer/Order/OrderGrid";

interface OrdersProps {}

const Orders: React.FunctionComponent<OrdersProps> = (props) => {
  const [orderType, setOrderType] = React.useState("All");
  const [enablePay, setEnablePay] = React.useState(false);
  const [openCheckout, setOpenCheckout] = React.useState(false);
  const handlePayButton = (value: boolean) => {
    setEnablePay(value);
  };
  const handleSelectChange = (event: any) => {
    setOrderType(event.target.value);
  };

  const handleOpenCheckout = () => {
    setOpenCheckout(true);
  };
  const handleCloseCheckout = () => {
    setOpenCheckout(false);
  };

  return (
    <>
      <Container maxWidth="xl">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h6" gutterBottom>
            Orders
          </Typography>
          <Box display="flex" gap={6} alignItems="center">
            <Button
              size="small"
              variant="contained"
              color="warning"
              disabled={!enablePay}
              onClick={handleOpenCheckout}
            >
              Pay Now
            </Button>
            <Select
              value={orderType}
              sx={{ width: "130px" }}
              onChange={handleSelectChange}
              variant="standard"
            >
              <MenuItem selected value="All">
                All
              </MenuItem>
              <MenuItem value="SO">Service Order</MenuItem>
              <MenuItem value="RO">Retail Order</MenuItem>
              <MenuItem value="Q">Quotation</MenuItem>
            </Select>
          </Box>
        </Stack>

        <Card>
          <Box sx={{ height: 600, width: "100%" }}>
            <OrderGrid
              orderType={orderType}
              handlePayButton={handlePayButton}
              openCheckout={openCheckout}
              handleCloseCheckout={handleCloseCheckout}
            ></OrderGrid>
          </Box>
        </Card>
      </Container>
    </>
  );
};

export default Orders;
